import { useEffect, useRef, useState } from 'react'
import { Select } from './Select'

import { salary } from '../../i18n/translatedMessages'

export function DefinitionModal({ item, show, onClick, close, lists, id }) {
	const modalRef = useRef(null)

	const [data, setData] = useState(null)
	const [subareas, setSubareas] = useState([])

	useEffect(() => {
		if (item) {
			setSubareas(lists.subareas.filter(subarea => subarea.area === item.area.id) || [])

			setData({
				level: item.level.id,
				area: item.area.id,
				subarea: item.subarea,
			})
		}
	}, [item])

	useEffect(() => {
		if (data?.area) {
			setSubareas(lists.subareas.filter(subarea => subarea.area === data.area) || [])

			const [value] = lists.subareas.filter(subarea => subarea.area === item?.area?.id)

			if (value) {
				setData({
					...data,
					subarea: value.id,
				})
			}
		}
	}, [data?.area])

	const handleChange = event => {
		setData({
			...data,
			[event.target.name]: event.target.value,
		})
	}

	const handleSave = () => {
		const response = {
			level_id: data.level,
			area_id: data.area,
			subarea_id: data.subarea,
		}

		onClick(response, id)
		close()
		setData(null)
	}

	if (show) {
		return (
			<div
				ref={modalRef}
				className='tw-absolute tw-z-50 tw-flex tw-items-center tw-justify-center tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-bg-gray-900/10 tw-backdrop-blur-sm'
			>
				<div className='tw-p-5 tw-rounded-xl tw-shadow-xl tw-bg-white tw-max-w-[1140px] tw-w-full tw-text-black'>
					<h4 className='tw-mb-8'>{salary.modalDefinitionsTitle}</h4>
					<div className='tw-flex tw-flex-col tw-gap-4 tw-items-start'>
						<div className='tw-flex tw-w-full tw-gap-2'>
							<div className='tw-w-full'>
								<label className='tw-font-normal' htmlFor=''>
									{salary.modalDefinitionsLevel}
								</label>
								<Select name='level' onChange={handleChange} list={lists.levels} value={data?.level || null} />
							</div>
							<div className='tw-w-full'>
								<label className='tw-font-normal' htmlFor=''>
									{salary.modalDefinitionsArea}
								</label>
								<Select name='area' onChange={handleChange} list={lists.areas} value={data?.area || null} />
							</div>
						</div>
						<div className='tw-w-full'>
							<label className='tw-font-normal' htmlFor=''>
								{salary.modalDefinitionsSubarea}
							</label>
							<Select name='subarea' onChange={handleChange} list={subareas} value={data?.subarea || null} />
						</div>
						<div className='tw-grid tw-grid-cols-2 tw-w-full'>
							<div></div>
							<div className='tw-flex tw-gap-4 tw-mt-5 tw-w-full '>
								<button
									onClick={close}
									className='tw-rounded-full tw-py-2 tw-px-3 tw-w-full tw-bg-white hover:tw-bg-[#DFE9F8]'
									style={{ border: '1px solid #CBD5E1' }}
								>
									{salary.modalDefinitionsBtnCancel}
								</button>
								<button
									onClick={handleSave}
									className='tw-rounded-full tw-py-2 tw-px-3 tw-w-full tw-text-white tw-bg-purple hover:tw-bg-purple-700'
									style={{ border: '1px solid #7a6be8' }}
								>
									{salary.modalDefinitionsBtnSave}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return <></>
}
